<template>
    <cart-item-base
        :item="item"
        :readonly="readonly"
    >
        <template slot-scope="{ removeItem, updateQuantity }">
            <li class="cart-listitem">
                        <span class="product-img">
                            <span :style="'background-image: url(' + item.image + ')'" :title="item.name"></span>
                        </span>
                <span class="product-ext">
                            <input type="textbox" name="qty" :value="item.quantity" disabled=""
                                   style="width: 2em; border: 0; padding-left: 0; padding-right: 0; text-align: right;">
                            {{ __('db') }}
                            <span class="product-total">{{ item.totalPrice.gross | currency(currencyFormat(item.currency)) }}</span>
                        </span>
                <span class="product-txt">
                            <span class="product-name"> {{ item.name }}</span><br>
                           {{ __('méret: :size', {size: item.size}) }}<br>
                           {{ __('szín: :color', {color: item.color + (item.color2 ? ' - ' + item.color2 : '') + (item.pattern ? ' - ' + item.pattern : '')  }) }}
                        </span>
            </li>
        </template>
    </cart-item-base>
</template>

<script>
import modifiesQuantity from '../../mixins/modifiesQuantity'
import currencyFormatter from '../../mixins/currencyFormatter';

export default {
    name: 'CartWidgetItem',
    mixins: [modifiesQuantity, currencyFormatter],
    props: {
        item: {
            type: Object,
            required: true
        },

        readonly: {
            type: Boolean,
            default: false
        },
    }
}
</script>

<style lang="scss" scoped>
.remove-item {
    margin: 5px;
    width: 25px;
}
</style>
